// C62路数据
export const data_C62 = {
    loadSceneId: '3424399539683520',
    mainTitle: '达川区C62桥东村三组公路(石梯镇天生桥村至渠县文崇界段)',  // 新增字段
    loadingModel: [
    //   {
    //     Id: '100031110081',
    //     project: '',
    //     location: { lat: 31.1310597, lon: 107.1971763, alt: 1 },
    //     viewToken: ''
    //   },
    //   {
    //     Id: '100031109687',
    //     project: '',
    //     location: { lat: 31.1310597, lon: 107.1971763, alt: 1 },
    //     viewToken: ''
    //   }
    ],
    // data/173.js 和 data/C62.js
  // ... 其他字段
  projectStats: {
    constructionContent: '2.175km三级公路提升改造',
    budgetAmount: '1451.4631',
    plannedDuration: '185',
    totalMaterialIn进场: '31次',
    todayMaterialIn进场: '0次'
  
  // ... 其他字段
},

    markerLocations: [
      {
        name: 'K0+000-K2+150',
        lat: 31.130086,
        lon: 107.192500,
        alt: 1,
        imgUrl: require('../png/黄.png'),
        color: '#FFD700',
        id: '544',
        status: 'yellow',
        subgradeEarthwork: 'yellow',
        subgradeSupport: 'yellow',
        subgradeBridge: 'yellow',
        subgradeDrainage: 'yellow',
        bridge: 'red',
        trafficSafety: 'red',
        fileList: [],
        worldposition: { x: -5.76, y: -52.26, z: 1 }
      }
    ],
    
    qualityData: {
      title: '质量问题情况',
      stats: {
        total: 8,
        serious: 0,
        rectified: 8,
        rectificationRate: '100.00%'
      },
      chart: {
        categories: ['路基土石方', '路基支档', '路基桥涵', '路基排水', '桥梁'],
        values: [1, 2, 4, 1, 0]
      }
    },
safetyData: {
        title: '安全隐患情况',
        stats: {
          total: 15,  // 14+9+7+4+5
          highRisk: 5,
          mediumRisk: 15,
          lowRisk: 5,
          rectificationRate: '100.00%'
        },
        chart: {
          data: [
            { value: 2, name: '高空作业', color: '#ff6b6b' },
            { value: 3, name: '临时用电', color: '#ffd93d' },
            { value: 4, name: '消防设施', color: '#6bcfff' },
            { value: 2, name: '机械伤害', color: '#a855f7' },
            { value: 4, name: '其他隐患', color: '#00ffcc' }
          ]
        }
      },
      constructionData: {
        earthwork: 3,      // 土方
        labor: 44,            // 劳务
        latticeBeam: 0,     // 格构梁
        total: 47          // 共计
      },
    imageFolder: './Sources/C62'
  }
  